(function ($) {

	var slideMinNumber,
		slideMaxNumber,
		width = $(window).width();

	if (width < 430) {
		slideMinNumber = 1;
		slideMaxNumber = 1;
	} else if (width < 770) {
		slideMinNumber = 2;
		slideMaxNumber = 2;
	} else {
		slideMinNumber = 4;
		slideMaxNumber = 4;
	}

	if ($('.news-slider .bxslider').length) {
		var newsCarousel = $('.news-slider .bxslider');

		newsCarousel = newsCarousel.bxSlider({
			minSlides: slideMinNumber,
			maxSlides: slideMaxNumber,
			slideWidth: 1000,
			slideMargin: 20,
			pager: false
		});

		$(window).resize(function () {
			newsCarousel.reloadSlider();
		});
	}

})(jQuery);